/**
 * Created by vtbelo on 01.04.2021
 */

const Merge2UnitsShopTab = function (tab) {
    cleverapps.EventEmitter.call(this);

    this.tab = tab;
};

Merge2UnitsShopTab.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2UnitsShopTab.prototype.constructor = Merge2UnitsShopTab;

Merge2UnitsShopTab.prototype.load = function (stored = {}) {
    this.refreshTime = stored.refresh || 0;
    this.fresh = stored.fresh || false;
    this.units = stored.units;

    delete stored.refresh;
    delete stored.buyed;
    delete stored.fresh;
    delete stored.units;

    this.buyed = stored;

    this.runRefreshTimeout();
};

Merge2UnitsShopTab.prototype.save = function () {
    return {
        refresh: this.refreshTime,
        fresh: !!this.fresh,
        units: this.units,
        ...this.buyed
    };
};

Merge2UnitsShopTab.prototype.getLeftTime = function () {
    return this.refreshTime + Merge2UnitsShop.getConfig(this.tab).refreshTimeout - Date.now();
};

Merge2UnitsShopTab.processCartUnits = function (cart) {
    if (Merge2UnitsShop.cartRewards && Merge2UnitsShop.cartRewards.length) {
        Merge2UnitsShop.cartRewards.forEach((reward) => {
            reward.collectRewardsAnimation(cart.firstItem);
        });
        Merge2UnitsShop.cartRewards = undefined;
    }
};

Merge2UnitsShopTab.getCartAmount = function () {
    if (!Merge2UnitsShop.cartRewards) {
        return 0;
    }
    return Merge2UnitsShop.cartRewards.reduce((amount, reward) => amount + reward.getAmount(), 0);
};

Merge2UnitsShopTab.clearCardRewards = function () {
    if (Merge2UnitsShop.cartRewards) {
        Merge2UnitsShop.cartRewards = undefined;
    }
};

Merge2UnitsShopTab.prototype.buy = function (product, videoBonus) {
    this.buyed[product.itemId] = (this.buyed[product.itemId] || 0) + 1;

    cleverapps.user.incProgressCompare();
    cleverapps.unitsShop.save();

    if (!product.price) {
        PushHelper.sendPush(PUSHES.FREE_CHEST, this.getLeftTime());
    }

    if (!Merge2UnitsShop.cartRewards) {
        Merge2UnitsShop.cartRewards = [];
    }

    for (let i = videoBonus ? 2 : 1; i > 0; --i) {
        product.unit.forEach((unitProduct) => {
            const unitReward = new Reward("units", unitProduct, { waitingSpawn: true, event: cleverapps.EVENTS.EARN.UNITS_SHOP });
            unitReward.receiveReward();

            if (product.price <= 0 || product.price === undefined) {
                Field.mapEvent(Field.BUY_FREE_UNIT, { tab: this.tab });
            }

            Merge2UnitsShop.cartRewards.push(unitReward);
        });
    }

    this.trigger("stateChanged");
    this.trigger("onBought");
};

Merge2UnitsShopTab.prototype.runRefreshTimeout = function () {
    if (this.refreshTimeout) {
        clearTimeout(this.refreshTimeout);
        delete this.refreshTimeout;
    }

    if (this.getLeftTime() > 0) {
        this.refreshTimeout = new cleverapps.LongTimeout(this.refreshProducts.bind(this, true), this.getLeftTime());
    } else {
        this.refreshProducts(true);
    }
};

Merge2UnitsShopTab.prototype.getFreeProduct = function () {
    return this.generateProducts(false).find((product) => !product.price && product.left > 0);
};

Merge2UnitsShopTab.prototype.listGeneratorsDropCodes = function () {
    const dropCodes = {};

    cleverapps.unitsLibrary.listAvailableByType("generator").forEach((generatorCode) => {
        const lastOpenStage = cleverapps.unitsLibrary.getLastOpenStage(generatorCode);
        if (lastOpenStage === undefined) {
            return;
        }

        Families[generatorCode].units.forEach((unitData, stage) => {
            if (stage <= lastOpenStage && unitData.generator && unitData.generator.drop) {
                unitData.generator.drop.forEach((code) => {
                    dropCodes[code] = true;
                });
            }
        });
    });

    return Object.keys(dropCodes);
};

Merge2UnitsShopTab.prototype.listSideQuestDrops = function () {
    const sideQuestCustomer = Merge2.current.customers.getSideQuestCustomer();
    const sideQuestCode = sideQuestCustomer && sideQuestCustomer.recipe.sideQuest;

    if (!sideQuestCode) {
        return [];
    }

    const config = OrdersAlgoConfig.generators[sideQuestCode];
    return (config.algorithm && config.algorithm.overrideDrop) || config.stages[UnitsLibrary.LastStage(sideQuestCode).stage].drop;
};

Merge2UnitsShopTab.prototype.listSideQuestResources = function (maxStage) {
    const resources = [];

    this.listSideQuestDrops().forEach((code) => {
        for (let stage = 0; stage <= maxStage; stage++) {
            if (LinePrices[code] && LinePrices[code][stage]) {
                resources.push({ code, stage, price: LinePrices[code][stage] });
            }
        }
    });

    return resources;
};

Merge2UnitsShopTab.prototype.listResourceUnits = function () {
    const units = [];

    this.listGeneratorsDropCodes().forEach((code) => {
        if (!Families[code] || Unit.isSideQuest(code)) {
            return;
        }

        const lastOpenStage = cleverapps.unitsLibrary.getLastOpenStage(code);
        if (lastOpenStage === undefined) {
            return;
        }

        for (let stage = 0; stage <= lastOpenStage; stage++) {
            if (LinePrices[code] && LinePrices[code][stage]) {
                units.push({ code, stage });
            }
        }
    });

    return units;
};

Merge2UnitsShopTab.prototype.listResourceCandidates = function (slot, context) {
    const minStage = slot.minStage || 0;
    const maxStage = slot.maxStage === "opened" || slot.maxStage === undefined ? Infinity : slot.maxStage;

    const inRange = context.pool.filter((unit) => unit.stage <= maxStage);

    const maxAvailable = inRange.reduce((max, unit) => Math.max(max, unit.stage), 0);
    const effectiveMin = Math.min(minStage, maxAvailable);

    return inRange.filter((unit) => unit.stage >= effectiveMin);
};

Merge2UnitsShopTab.prototype.countResourceLineages = function (slot, context) {
    if (slot.unitType !== "resource") {
        return Infinity;
    }

    const codes = {};
    this.listResourceCandidates(slot, context).forEach((unit) => {
        codes[unit.code] = true;
    });

    return Object.keys(codes).length;
};

Merge2UnitsShopTab.prototype.chooseResourceUnit = function (slot, context) {
    const candidates = this.listResourceCandidates(slot, context);

    if (!candidates.length) {
        return undefined;
    }

    // prefer the least-used lineage, then the least-used exact unit, so resources come from different
    // lines when possible and duplicate minimally otherwise (the pool is pre-shuffled to break ties)
    const codeUses = (unit) => context.usedCodes[unit.code] || 0;
    const unitUses = (unit) => context.usedUnits[`${unit.code}_${unit.stage}`] || 0;

    const unit = candidates.reduce((chosen, current) => {
        if (codeUses(current) !== codeUses(chosen)) {
            return codeUses(current) < codeUses(chosen) ? current : chosen;
        }
        return unitUses(current) < unitUses(chosen) ? current : chosen;
    });

    return { code: unit.code, stage: unit.stage, price: LinePrices[unit.code][unit.stage] };
};

Merge2UnitsShopTab.prototype.chooseGeneratorUnit = function (slot, pseudo) {
    const minStage = slot.minStage || 0;

    const candidates = [];
    cleverapps.unitsLibrary.listAvailableByType("generator").forEach((code) => {
        if (!LinePrices[code]) {
            return;
        }

        const lastOpenStage = cleverapps.unitsLibrary.getLastOpenStage(code);
        if (lastOpenStage === undefined) {
            return;
        }

        let maxStage = minStage;
        if (slot.maxStage === "opened") {
            maxStage = lastOpenStage;
        } else if (slot.maxStage !== undefined) {
            maxStage = slot.maxStage;
        }

        for (let stage = minStage; stage <= maxStage; stage++) {
            if (LinePrices[code][stage]) {
                candidates.push({ code, stage, price: LinePrices[code][stage] });
            }
        }
    });

    return pseudo.choose(candidates);
};

Merge2UnitsShopTab.prototype.chooseSideQuestUnit = function (slot, pseudo) {
    const minStage = slot.minStage || 0;

    const resources = this.listSideQuestResources(slot.maxStage).filter((resource) => resource.stage >= minStage);

    return pseudo.choose(resources);
};

Merge2UnitsShopTab.prototype.chooseBoosterUnit = function (slot, context) {
    const boosters = Merge2UnitsShop.getConfig(this.tab).boosters || {};

    const candidates = {};
    Object.keys(boosters).forEach((code) => {
        if (!Families[code] || !LinePrices[code]) {
            return;
        }

        const stages = [];
        boosters[code].forEach((stock, stage) => {
            if (stock > 0 && Families[code].units[stage] && LinePrices[code][stage]) {
                stages.push(stage);
            }
        });

        if (stages.length) {
            candidates[code] = stages;
        }
    });

    const codes = Object.keys(candidates);
    if (!codes.length) {
        return undefined;
    }

    const minUses = Math.min(...codes.map((code) => context.usedCodes[code] || 0));
    const code = context.pseudo.choose(codes.filter((candidate) => (context.usedCodes[candidate] || 0) === minUses));
    const stage = context.pseudo.choose(candidates[code]);

    return { code, stage, price: LinePrices[code][stage] };
};

Merge2UnitsShopTab.prototype.resolveSlotUnit = function (template, context) {
    switch (template.unitType) {
        case "resource":
            return this.chooseResourceUnit(template, context);
        case "generator":
            return this.chooseGeneratorUnit(template, context.pseudo);
        case "sidequest":
            return this.chooseSideQuestUnit(template, context.pseudo);
        case "booster":
            return this.chooseBoosterUnit(template, context);
        default:
            return undefined;
    }
};

Merge2UnitsShopTab.prototype.createResolveContext = function () {
    const pseudo = PseudoRandom.GET("unitsshop");
    pseudo.seed(this.refreshTime);

    return {
        pseudo,
        pool: pseudo.shuffle(this.listResourceUnits()),
        usedCodes: {},
        usedUnits: {}
    };
};

Merge2UnitsShopTab.prototype.markUsed = function (context, unit) {
    context.usedCodes[unit.code] = (context.usedCodes[unit.code] || 0) + 1;
    context.usedUnits[`${unit.code}_${unit.stage}`] = (context.usedUnits[`${unit.code}_${unit.stage}`] || 0) + 1;
};

Merge2UnitsShopTab.prototype.resolveSlot = function (slot, context) {
    if (slot.unit) {
        const unit = { code: slot.unit.code, stage: slot.unit.stage };
        if (slot.type === Product.TYPE_FREE) {
            unit.free = true;
        }
        return unit;
    }

    const variants = slot.random ? context.pseudo.shuffle(slot.random.slice()) : [slot];

    let resolved;
    for (let i = 0; i < variants.length && !resolved; i++) {
        resolved = this.resolveSlotUnit(variants[i], context);
    }

    if (!resolved) {
        return null;
    }

    this.markUsed(context, resolved);

    return { code: resolved.code, stage: resolved.stage };
};

Merge2UnitsShopTab.prototype.resolveUnits = function () {
    const config = Merge2UnitsShop.getConfig(this.tab);
    const context = this.createResolveContext();

    const units = [];

    config.slots
        .map((slot, index) => ({ slot, index, freedom: this.countResourceLineages(slot, context) }))
        .sort((a, b) => a.freedom - b.freedom || a.index - b.index)
        .forEach((entry) => {
            units[entry.index] = this.resolveSlot(entry.slot, context);
        });

    return units;
};

// Replace saved sidequest units that no longer belong to the current sidequest with freshly resolved ones.
Merge2UnitsShopTab.prototype.refreshSideQuestUnits = function (units) {
    const config = Merge2UnitsShop.getConfig(this.tab);
    const drops = this.listSideQuestDrops();

    let context;
    let changed = false;

    const newUnits = units.slice();

    units.forEach((unit, index) => {
        if (!unit || !Families[unit.code] || !Unit.isSideQuest(unit.code) || drops.indexOf(unit.code) !== -1) {
            return;
        }

        if (!context) {
            context = this.createResolveContext();
            units.forEach((other, otherIndex) => {
                if (other && otherIndex !== index) {
                    this.markUsed(context, other);
                }
            });
        }

        newUnits[index] = this.resolveSlot(config.slots[index], context);
        changed = true;
    });

    if (changed) {
        cleverapps.unitsShop.save();
    }

    return newUnits;
};

Merge2UnitsShopTab.prototype.buildProduct = function (slot, saved) {
    // fixed slots never depend on library state or the saved list, so rebuild them straight from config
    if (slot.unit) {
        const price = slot.type === Product.TYPE_FREE ? 0 : LinePrices[slot.unit.code] && LinePrices[slot.unit.code][slot.unit.stage];
        return this.fillTemplate(slot, { price });
    }

    if (!saved) {
        return;
    }

    const spec = slot.random ? slot.random[0] : slot;

    let left = spec.left;
    if (spec.unitType === "booster") {
        const boosters = Merge2UnitsShop.getConfig(this.tab).boosters;
        left = boosters[saved.code] && boosters[saved.code][saved.stage];
    }

    return this.fillTemplate({
        unit: { amount: 1 },
        type: spec.type || Product.TYPE_HARD,
        left,
        ads: spec.ads
    }, {
        code: saved.code,
        stage: saved.stage,
        price: saved.free ? 0 : LinePrices[saved.code] && LinePrices[saved.code][saved.stage]
    });
};

Merge2UnitsShopTab.prototype.needsAttention = function () {
    const freeProduct = this.generateProducts(false).find((p) => p.price === 0);

    return cleverapps.unitsShop.isAvailable() && freeProduct && freeProduct.left > 0;
};

Merge2UnitsShopTab.prototype.generateProducts = function (saveUnits = true) {
    const config = Merge2UnitsShop.getConfig(this.tab);

    let units = this.units;

    if (units && units.length === config.slots.length) {
        units = this.refreshSideQuestUnits(units);
    } else {
        units = this.resolveUnits();
    }

    const products = config.slots.map((slot, index) => this.buildProduct(slot, units[index])).filter(Boolean);

    if (cleverapps.tutorial.isActive()) {
        products.forEach((product) => {
            if (product.videoBonus) {
                product.videoBonus = false;
            }
        });
    }

    if (saveUnits) {
        this.units = units;
        cleverapps.unitsShop.save();
    }

    return products;
};

Merge2UnitsShopTab.prototype.fillTemplate = function (template, options) {
    options = options || {};

    template = cleverapps.clone(template, true);

    template.tutorial = options.tutorial;

    template.tab = this.tab;
    template.price = options.price || 0;

    template.unit = cleverapps.toArray(template.unit || []).map((unitTemplate) => {
        const code = unitTemplate.code || options.code;
        const stage = unitTemplate.stage || options.stage || 0;
        const amount = unitTemplate.amount || 1;

        const family = Families[code];
        if (!family) {
            return;
        }

        if (!Merge2.current.families[code]) {
            return;
        }

        return { code, stage, amount };
    }).filter(Boolean);

    if (!template.unit.length) {
        return;
    }

    if (!template.ads && Merge2UnitsShop.getConfig(this.tab).ads) {
        const unit = template.unit[0];
        template.ads = template.price > 0 && unit.stage <= 1 && unit.stage < Families[unit.code].units.length - 1;
    }

    template.itemId = `${template.unit[0].code}_${template.unit[0].stage}_${template.unit[0].amount}_${template.left || 0}`;
    template.stock = template.left;
    template.left -= this.buyed[template.itemId] || 0;

    // Single- vs multi-unit tile is chosen by the unit count (old Merge2UnitsShopTileModel view class).
    template.prefab = template.unit.length > 1
        ? bundles.tile_shop.jsons.merge2unitsshopmultitile_prefab_json
        : bundles.tile_shop.jsons.merge2unitsshoptile_prefab_json;

    // Free units draw attention while stock remains (old isFree() && isAvailable(); a free unit is
    // never an ADS product, so availability reduces to stock left).
    template.isAttention = function () {
        return this.type === Product.TYPE_FREE && this.left > 0;
    };

    return template;
};

Merge2UnitsShopTab.prototype.countBoughtProducts = function () {
    const freeProducts = this.generateProducts(false).filter((product) => !product.price);

    const freeKeys = freeProducts.map((product) => product.itemId);

    let amount = 0;
    for (const boughtKey in this.buyed) {
        if (freeKeys.indexOf(boughtKey) === -1) {
            amount += this.buyed[boughtKey];
        }
    }

    return amount;
};

Merge2UnitsShopTab.prototype.buyRefresh = function (f) {
    if (this.countBoughtProducts() > 0) {
        if (this.isAdsRefreshAvailable()) {
            cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.REFRESH_SHOP_PB, () => {
                this.refreshProducts();
                f();
            });
        } else if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.REFRESH, Merge2UnitsShop.getConfig(this.tab).refreshPrice)) {
            this.refreshProducts();
            f();
        }
    }
};

Merge2UnitsShopTab.prototype.isAdsRefreshAvailable = function () {
    return false;
};

Merge2UnitsShopTab.prototype.refreshProducts = function (fresh) {
    this.refreshTime = cleverapps.getCooldownStartTime(Merge2UnitsShop.getConfig(this.tab).refreshTimeout);
    this.fresh = fresh;
    this.buyed = {};
    this.units = undefined;

    this.runRefreshTimeout();
    cleverapps.unitsShop.save();
};

Merge2UnitsShopTab.prototype.setFreshShown = function () {
    if (this.fresh) {
        this.fresh = false;
        cleverapps.unitsShop.save();
    }
};
